<section class="form-wrapper" *ngIf="pageData">
  <div class="form-with-cover">
    <div class="form-container">
      <div class="form-title-container">
        <ng-container
          *ngIf="authService.migratedUserMustReset; else standardTitle"
        >
          <h1>
            {{ pageData.migrated_heading || 'Forgotten your password?' }}
          </h1>
          <p>
            {{
              pageData.migrated_message ||
                "We've migrated your account to our new system. This requires you to reset your password."
            }}
            {{
              pageData.message ||
                "Just enter the email address you registered with and we'll send you a link so you can reset your password. Don't forget - if you registered for My Endsleigh using your social account, select Facebook, Instagram or Google on the Login page to sign in."
            }}
          </p>
        </ng-container>
        <ng-template #standardTitle>
          <ng-container *ngIf="!authService.migratedUserMustReset">
            <h1 class="forgotten">
              {{ pageData.heading || 'Forgotten your password?' }}
            </h1>
          </ng-container>
          <p>
            {{ pageData.spam_message || "Don't worry, these things happen." }}
            {{
              pageData.message ||
                "Just enter the email address you registered with and we'll send you a link so you can reset your password. Don't forget - if you registered for My Endsleigh using your social account, select Facebook, Instagram or Google on the Login page to sign in."
            }}
          </p>
        </ng-template>
      </div>

      <form
        *ngIf="showForm; else successfulReset"
        action=""
        (ngSubmit)="onSubmit()"
      >
        <div class="form-row">
          <div class="form-field">
            <label for="email" class="email-text">{{
              pageData.email_label || 'Email address'
            }}</label>
            <input
              [formControl]="email"
              type="email"
              id="email"
              required
              [class.error]="emailSubmitted && email.invalid"
            />
            <span *ngIf="!email.value && emailSubmitted" class="error">
              {{
                pageData.email_tooltip ||
                  'Please enter your email address to continue.'
              }}
            </span>
            <span
              *ngIf="email.invalid && email.value?.length && emailSubmitted"
              class="error"
            >
              {{
                pageData.valid_email_tooltip ||
                  'Please enter a valid email address.'
              }}
            </span>
          </div>
        </div>

        <div class="error-block-container">
          <app-error-block *ngIf="showEmailError">
            {{ emailErrorText }}
          </app-error-block>
        </div>

        <div class="button-container">
          <button
            [class.button-loading]="formLoading"
            type="submit"
            class="submit-button"
          >
            <span>{{ pageData.submit_text || 'Submit' }}</span>
          </button>
        </div>
      </form>
      <ng-template #successfulReset>
        <app-success-block>
          {{ pageData.check_inbox_text || 'Please check your inbox' }}
        </app-success-block>
      </ng-template>
    </div>

    <div class="cover-container" *ngIf="pageData?.cover_image">
      <img
        [src]="pageData.cover_image.data.attributes.url"
        alt="Registration Cover Image"
      />
    </div>
  </div>
</section>
